import { Component, IMessagingService } from "@se/designsystem-core";
import { waitForElement } from "@se/designsystem-core";
import { FBSConfig } from "../configuration/FBSConfig";

class LiveChatPopupComponent extends Component {

    private popupDialogEl: HTMLDialogElement;
    private popupCloseButtonEl: HTMLButtonElement;
    private popupNoThanksButtonEl: HTMLButtonElement;
    private openLiveChatButtonEl: HTMLButtonElement;
    private liveChatImageEl: HTMLImageElement;
    private liveChatConversationDivEl: HTMLDivElement;
    
    private liveChatDialogTitleEl: HTMLElement;
    private firstFocusableDialogElement: HTMLElement;
    private focusableDialogElements: NodeListOf<HTMLElement>;
    private lastFocusableDialogElement: HTMLElement;

    constructor(componentEl: HTMLElement,
        messagingService: IMessagingService,
        private fbsConfig: FBSConfig ) {
        super(componentEl, messagingService);

        this.popupDialogEl = componentEl.querySelector<HTMLDialogElement>(".js-live-chat-popup-component-dialog");
        this.popupCloseButtonEl = componentEl.querySelector<HTMLButtonElement>(".js-live-chat-popup-component-close");
        this.popupNoThanksButtonEl = componentEl.querySelector<HTMLButtonElement>(".js-live-chat-popup-component-no-thanks");
        this.openLiveChatButtonEl = componentEl.querySelector<HTMLButtonElement>(".js-live-chat-popup-component-chat");

        this.firstFocusableDialogElement = this.popupDialogEl.querySelectorAll('button')[0] as HTMLButtonElement;
        this.focusableDialogElements = this.popupDialogEl.querySelectorAll('button'); 
        this.lastFocusableDialogElement = this.focusableDialogElements[this.focusableDialogElements.length - 1] as HTMLElement;

        this.popupNoThanksButtonEl.addEventListener("click", async (liveChatPopupComponentNoThanksClickedEvent: Event) => {
            liveChatPopupComponentNoThanksClickedEvent.preventDefault();
            this.closeLiveChatPopup();
        });     

        this.popupCloseButtonEl.addEventListener("click", async (liveChatPopupComponentCloseClickedEvent: Event) => {
            liveChatPopupComponentCloseClickedEvent.preventDefault();
            this.closeLiveChatPopup();
        });

        this.openLiveChatButtonEl.addEventListener("click", async (liveChatShowChatComponentClickedEvent: Event) => {
            liveChatShowChatComponentClickedEvent.preventDefault();
            this.openLiveChatPopup();
        });

        this.popupDialogEl.addEventListener("keydown", (e: KeyboardEvent) => {
            this.dialogKeyDownPressed(e);
        });

        if (this.popupDialogEl) {
            setTimeout(() => {
                this.showLiveChatPopupDialog();
            }, this.fbsConfig.LiveChatPopupDelay)
        }
    }

    protected showLiveChatPopupDialog = () => {
        // Only show popup after specified delay and once Live Chat is loaded and available
        waitForElement('.LPMimage').then(() => {
            this.liveChatImageEl  = document.querySelector<HTMLImageElement>(".LPMimage");

            this.liveChatConversationDivEl = document.querySelector<HTMLDivElement>("#lpChat");

            this.liveChatDialogTitleEl = document.querySelector<HTMLElement>(".js-live-chat-popup-component-title");

            if (this.liveChatImageEl.alt.toLowerCase().includes(this.fbsConfig.LiveChatEnabledText.toLowerCase()) && this.liveChatConversationDivEl == null)
            {
                this.popupDialogEl.showModal();
                this.liveChatDialogTitleEl.focus();
            }
        });
    };
    
    protected openLiveChatPopup = () => {
        if (this.liveChatImageEl) {
            this.popupDialogEl.close();
            this.liveChatImageEl.click()
        } else { 
            console.log("Problem opening Live Chat");
        }

    };

    protected closeLiveChatPopup = () => {
        this.popupDialogEl.close();
    };

    protected dialogKeyDownPressed = (e) => {

        if (e.key !== 'Tab' && e.keyCode !== 9) {
          return;
        }
    
        if (e.shiftKey) {
          if (document.activeElement === this.firstFocusableDialogElement) {
            this.lastFocusableDialogElement.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === this.lastFocusableDialogElement) {
            this.firstFocusableDialogElement.focus();
            e.preventDefault();
          }
        }
    }
}

export { LiveChatPopupComponent };
